export enum EventType {
  FarmerBooking = 1,
  PreInspectionbyAE = 2,
  RejectedbyAE = 3,
  DealerSelection = 4,
  DealerAuthenticate = 5,
  PaymentInfo = 6,
  ProductDeliveryInfo = 7,
  ManufacturerApproval = 8,
  AEApproval = 9,
  EEApproval = 10,
  ReleaseSubsidy = 11,
  AdditionalReleaseSubsidy = 12,
  // SubsidyRelease = 13,
  RequestforExemption = 14,
  ExemptionRequestVerifiedByAEE = 15,
  FarmerBookingCancelled = 16,
  ExemptionRequestAcceptbyFarmer = 17,
  DealerChange = 18,
  ProductChange = 19,
  ManufacturerSendBack = 20,
  AESendBack = 21,
  AEESendBack = 22,
  DealerSendBackUpdate = 23,
  ManufacturerSendBackUpdate = 24,
  AESendBackUpdate = 25,
  Admindealersendback = 26,
  AdminBookingCancelled = 27,
  AdminAEPhysicalVerifiedSendback = 28,
  SelectedInLottery = 29,
  NotSelectedInLottery = 30,
  ProductPlacementAtDealerPremises = 31,
  DealerPremisesVerification = 32,
  SubsidyReleaseToFarmer = 33,
  SubsidyPaymentInfoByDealer = 34,
  ManufacturerPlacementSendBack = 35,
  DealerPremisesVerificationSendBack = 36,
  SubsidyReleaseSendBack = 37,
  DealerPlacementSendBackUpdate = 38
}
